/** The four steps of the per-source funnel, in order. Payments is never a base. */
export const FUNNEL_STEPS = [
  { key: 'sessions', label: 'Session Start', opacity: 0.6, selectable: true },
  { key: 'visitors', label: 'Intake', opacity: 0.75, selectable: true },
  { key: 'emails', label: 'Emails', opacity: 0.9, selectable: true },
  { key: 'payments', label: 'Payments', opacity: 1, selectable: false },
]

/**
 * How one step of one source's funnel renders.
 *
 * With no base, each step is a % of the step before it (the base step shows no
 * %), and bar widths are relative to sessions. With a base, every step from the
 * base onward is a % of it, and the steps before it are muted with no %: "sessions
 * as a % of emails" is a number over 100 that answers no question.
 *
 * Widths are capped at 100: a later step can exceed an earlier one (a payment
 * whose visitor id never entered an email), and the % says so without the bar
 * overflowing.
 */
export function funnelStepView(row, key, base) {
  const index = FUNNEL_STEPS.findIndex(step => step.key === key)
  const value = row[key] || 0
  const ratio = (numerator, denominator) => denominator > 0 ? numerator / denominator * 100 : null
  const width = pct => Math.min(Math.max(pct ?? 0, 0), 100)
  if (!base) {
    const denominator = row.sessions || row.visitors || 0
    if (index === 0) return { width: row.sessions > 0 ? 100 : 0 }
    const previous = FUNNEL_STEPS[index - 1]
    return {
      width: width(ratio(value, denominator)),
      pct: ratio(value, row[previous.key] || 0),
      title: `${FUNNEL_STEPS[index].label} ÷ ${previous.label}`,
    }
  }
  const baseIndex = FUNNEL_STEPS.findIndex(step => step.key === base)
  if (index < baseIndex) return { width: 100, muted: true }
  if (index === baseIndex) return { width: value > 0 ? 100 : 0 }
  const pct = ratio(value, row[base] || 0)
  return { width: width(pct), pct, title: `${FUNNEL_STEPS[index].label} ÷ ${FUNNEL_STEPS[baseIndex].label}` }
}
